const hoverHandler = {
    mounted(el: any, binding: any) {
        // 获取当前节点的所有样式
        const originalStyle = window.getComputedStyle(el)
        const obj: any = {}

        for (const key in originalStyle) {
            obj[key] = originalStyle[key]
        }

        // 鼠标划入事件
        el._mouseover = (e: any) => {
            for (const key in binding.value) {
                el.style[key] = binding.value[key]
            }
        }
        // 鼠标划出事件
        el._mouseout = (e: any)=>{
            for (const key in binding.value) {
                el.style[key] = obj[key]
            }
        }

        // 挂载事件
        el.addEventListener("mouseover", el._mouseover)
        el.addEventListener("mouseout",el._mouseout)
    },
    unmounted(el: any) {
        // 卸载事件
        el.removeEventListener("mouseover", el._mouseover)
        el.removeEventListener("mouseout", el._mouseout)
    },
};
(hoverHandler as any).install = function (app) {
    app.directive("hover", hoverHandler);
  };
  
export default hoverHandler